import React, { createContext, useReducer, useCallback } from 'react';
import { getApiUrl } from '../config';

const initialState = {
    products: [],
    loading: true,
    error: null,
    productDetails: null,
    filteredProducts: [],
    selectedCategory: null,
    store: null,
    currentPage: 1,
    maxPrice: "",
    minPrice: "",
    campaignProduct: [],
    sort: '',
    searchs: [],
};


const productReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_PRODUCTS_SUCCESS':

            const existingIds = new Set(state.products.map(p => p.id));
            const newProducts = action.payload.filter(p => !existingIds.has(p.id));
            return {
                ...state,
                products: [...state.products, ...newProducts],
                loading: false
            };
        case 'FETCH_PRODUCTS_ERROR':
            return { ...state, loading: false, error: action.payload };
        case 'SET_SELECTED_PRODUCT':
            return { ...state, productDetails: action.payload, loading: false, loadingProduct: false };
        case 'FETCH_CATEGORY_PRODUCTS_SUCCESS':
            const existingIdss = new Set(state.filteredProducts.map(p => p.id));
            const newUniqueProducts = action.payload.filter(p => !existingIdss.has(p.id));

            return {
                ...state,
                filteredProducts: state.currentPage === 1
                    ? action.payload
                    : [...state.filteredProducts, ...newUniqueProducts],
                selectedCategory: action.kategori,
                loading: false
            };
        case 'FETCH_STORE_SUCCCESS':
            return { ...state, store: action.payload, loading: false };

        case 'INCREMENT_PAGE':
            return { ...state, currentPage: state.currentPage + 1 };
        case 'FILTER_BY_PRICE':
            const filteredByPrice = state.filteredProducts.length > 0 ? state.filteredProducts : state.products;
            const filtered = filteredByPrice.filter(product => {
                const price = parseFloat(product.fiyat);
                return (
                    (state.minPrice === '' || price >= parseFloat(state.minPrice)) &&
                    (state.maxPrice === '' || price <= parseFloat(state.maxPrice))
                );
            });
            return {
                ...state,
                filteredProducts: filtered,
            };
        case 'SEARCH_PRODUCTS_SUCCESS':
            // Benzersiz sonuçları api sonuçlarından filtrele
            const uniqueResults = {};
            action.payload.forEach(product => {
                const key = `${product.baslik}_${product.sef}`;
                if (!uniqueResults[key]) {
                    uniqueResults[key] = product;
                }
            });
            return {
                ...state,
                searchs: Object.values(uniqueResults),
                loading: false
            };
        case 'RESET_PRODUCTS':
            return { ...state, products: [], loading: true, currentPage: 1 };
        case 'SET_MIN_PRICE':
            return {
                ...state,
                minPrice: action.payload,
            };
        case 'SET_MAX_PRICE':
            return {
                ...state,
                maxPrice: action.payload,
            };
        case 'SET_SORT_OPTION':
            return { ...state, sort: action.payload };
        case 'SET_LOADING':
            return { ...state, loading: action.payload, error: null };
        case 'FETCH_CAMPAIGN_PRODUCT_SUCCESS':
            return { ...state, campaignProduct: action.payload, loading: false }
        case 'SET_HAS_MORE':
            return {
                ...state,
                hasMore: action.payload
            };
        default:
            return state;
    }
};

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
    const [state, dispatch] = useReducer(productReducer, initialState);
    var son = false;
    const handleMinPriceChange = (e) => {

        dispatch({ type: 'SET_MIN_PRICE', payload: e.target.value });
    };

    const handleMaxPriceChange = (e) => {
        dispatch({ type: 'SET_MAX_PRICE', payload: e.target.value });
    };

    const filterByPrice = () => {
        dispatch({ type: 'FILTER_BY_PRICE' });
    };
    const fetchProducts = async (page) => {

        try {
            if (son) {
                return null;
            }
            const token = localStorage.getItem('token');
            const tkn = localStorage.getItem('tkn');
            const response = await fetch(`${getApiUrl()}/products?page=${page}`, {
                method: 'GET',
                headers: {
                    'Authorization': `${token}`,
                    'Tkn': `${tkn}`,
                    'Content-Type': 'application/json',

                },

            });
            const data = await response.json();
            if (data.length == 0) {
                son = true;
            }
            const correctedData = data.map(productItem => {
                let finalImage = { i1: 'placeholder.jpg' }; // Varsayılan fallback

                if (typeof productItem.image === 'object' && productItem.image !== null && productItem.image.hasOwnProperty('i1') && productItem.image.i1) {
                    // Zaten doğru formatta bir obje ise ve i1 doluysa direkt kullan
                    finalImage = productItem.image;
                } else if (typeof productItem.image === 'string' && productItem.image.trim() !== '') {
                    // String ise parse etmeyi dene
                    try {
                        const parsedImage = JSON.parse(productItem.image.replace(/\\/g, '\\')); // Gelen \ stringlerini koru, sonra parse et
                        // Parse edilen şeyin de beklenen yapıda olduğunu kontrol et
                        if (typeof parsedImage === 'object' && parsedImage !== null && parsedImage.hasOwnProperty('i1') && parsedImage.i1) {
                            finalImage = parsedImage;
                        } else {
                            console.warn('Parse edilen image beklenen yapıda değil veya i1 boş (fetchProducts):', productItem.id, 'Gelen image string:', productItem.image, 'Parse sonucu:', parsedImage);
                        }
                    } catch (error) {
                        console.error('Image JSON parse edilemedi (fetchProducts):', error, 'ID:', productItem.id, 'Sorunlu image string:', productItem.image);
                        // Parse hatası olursa varsayılan (yukarıda tanımlı placeholder) kullanılır.
                    }
                } else if (productItem.image) { 
                    // String veya obje değil ama boş/null da değilse (beklenmedik tip) veya obje ama i1 yoksa/boşsa
                    console.warn('Bilinmeyen veya eksik image formatı, placeholder kullanılıyor (fetchProducts):', productItem.id, 'Gelen image data:', productItem.image);
                }
                // Eğer productItem.image null veya boş string ise veya yukarıdaki koşullarda finalImage atanmadıysa zaten placeholder kullanılacak.

                return { ...productItem, image: finalImage };
            });
            dispatch({ type: 'FETCH_PRODUCTS_SUCCESS', payload: correctedData });

        } catch (error) {
            dispatch({ type: 'FETCH_PRODUCTS_ERROR', payload: error.message });
        }
    };

    const searchProducts = useCallback(async (query) => {

        try {
            const token = localStorage.getItem('token');
            const tkn = localStorage.getItem('tkn');
            const response = await fetch(`${getApiUrl()}/products?search=${query}&limit=200`, {
                method: 'GET',
                headers: {
                    'Authorization': `${token}`,
                    'Tkn': `${tkn}`,
                    'Content-Type': 'application/json',

                },

            });
            const data = await response.json();
            const correctedData = data.map(searchItem => {
                let finalImage = { i1: 'placeholder.jpg' }; // Varsayılan fallback

                if (typeof searchItem.image === 'object' && searchItem.image !== null && searchItem.image.hasOwnProperty('i1') && searchItem.image.i1) {
                    finalImage = searchItem.image;
                } else if (typeof searchItem.image === 'string' && searchItem.image.trim() !== '') {
                    try {
                        const parsedImage = JSON.parse(searchItem.image.replace(/\\/g, '\\'));
                        if (typeof parsedImage === 'object' && parsedImage !== null && parsedImage.hasOwnProperty('i1') && parsedImage.i1) {
                            finalImage = parsedImage;
                        } else {
                            console.warn('Parse edilen image beklenen yapıda değil veya i1 boş (searchProducts):', searchItem.id, 'Gelen image string:', searchItem.image, 'Parse sonucu:', parsedImage);
                        }
                    } catch (error) {
                        console.error('Image JSON parse edilemedi (searchProducts):', error, 'ID:', searchItem.id, 'Sorunlu image string:', searchItem.image);
                    }
                } else if (searchItem.image) {
                    console.warn('Bilinmeyen veya eksik image formatı, placeholder kullanılıyor (searchProducts):', searchItem.id, 'Gelen image data:', searchItem.image);
                }
                return { ...searchItem, image: finalImage };
            });
            dispatch({ type: 'SEARCH_PRODUCTS_SUCCESS', payload: correctedData });
        } catch (error) {
            dispatch({ type: 'FETCH_PRODUCTS_ERROR', payload: error.message });
        }
    }, [dispatch]);

    const fetchProductById = async (sef) => {
        dispatch({ type: 'SET_LOADING', payload: true });
        try {
            const token = localStorage.getItem('token');
            const tkn = localStorage.getItem('tkn');
            const response = await fetch(`${getApiUrl()}/product?sef=${sef}`, {
                method: 'GET',
                headers: {
                    'Authorization': `${token}`,
                    'Tkn': `${tkn}`,
                    'Content-Type': 'application/json',

                },

            });
            const productDetailsResponse = await response.json();
            
            let finalImage = { i1: 'no-image.png' };
            const productIdForLog = productDetailsResponse.id || sef;

            if (typeof productDetailsResponse.image === 'object' && productDetailsResponse.image !== null && productDetailsResponse.image.hasOwnProperty('i1') && productDetailsResponse.image.i1) {
                finalImage = productDetailsResponse.image;
            } else if (typeof productDetailsResponse.image === 'string' && productDetailsResponse.image.trim() !== '') {
                try {
                    const parsedImage = JSON.parse(productDetailsResponse.image.replace(/\\/g, '\\'));
                    if (typeof parsedImage === 'object' && parsedImage !== null && parsedImage.hasOwnProperty('i1') && parsedImage.i1) {
                        finalImage = parsedImage;
                    } else {
                         console.warn('Parse edilen image beklenen yapıda değil veya i1 boş (fetchProductById):', productIdForLog, 'Gelen image string:', productDetailsResponse.image, 'Parse sonucu:', parsedImage);
                    }
                } catch (error) {
                    console.error('Image JSON parse edilemedi (fetchProductById):', error, 'ID/SEF:', productIdForLog, 'Sorunlu image string:', productDetailsResponse.image);
                }
            } else if (productDetailsResponse.image) {
                 console.warn('Bilinmeyen veya eksik image formatı, placeholder kullanılıyor (fetchProductById):', productIdForLog, 'Gelen image data:', productDetailsResponse.image);
            }

            const productDetails = { ...productDetailsResponse, image: finalImage };                    
            fbq('track', 'ViewContent', {
                content_ids: [productDetails.id],
                content_type: 'product'
            });
            dispatch({ type: 'SET_SELECTED_PRODUCT', payload: productDetails });
        } catch (error) {
            dispatch({ type: 'FETCH_PRODUCTS_ERROR', payload: error.message });
        }
    }

    const fetchCategoryProducts = useCallback(async (kategori, page, sort) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (son) {
                    return null;
                }
                const token = localStorage.getItem('token');
                const tkn = localStorage.getItem('tkn');

                const response = await fetch(`${getApiUrl()}/products?category=${kategori}&page=${page}&sort=${sort}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${token}`,
                        'Tkn': `${tkn}`,
                        'Content-Type': 'application/json',

                    },

                });

                const data = await response.json();

                // Eğer data bir dizi değilse, hata fırlat
                if (!Array.isArray(data)) {
                    reject(new Error('Kategori bulunamadı'));
                    return;
                }

                if (data.length == 0) {
                    son = true;
                }
                const correctedData = data.map(categoryProductItem => {
                    let finalImage = { i1: 'placeholder.jpg' }; // Varsayılan fallback

                    if (typeof categoryProductItem.image === 'object' && categoryProductItem.image !== null && categoryProductItem.image.hasOwnProperty('i1') && categoryProductItem.image.i1) {
                        finalImage = categoryProductItem.image;
                    } else if (typeof categoryProductItem.image === 'string' && categoryProductItem.image.trim() !== '') {
                        try {
                            const parsedImage = JSON.parse(categoryProductItem.image.replace(/\\/g, '\\'));
                            if (typeof parsedImage === 'object' && parsedImage !== null && parsedImage.hasOwnProperty('i1') && parsedImage.i1) {
                                finalImage = parsedImage;
                            } else {
                                console.warn('Parse edilen image beklenen yapıda değil veya i1 boş (fetchCategoryProducts):', categoryProductItem.id, 'Gelen image string:', categoryProductItem.image, 'Parse sonucu:', parsedImage);
                            }
                        } catch (error) {
                            console.error('Image JSON parse edilemedi (fetchCategoryProducts):', error, 'ID:', categoryProductItem.id, 'Sorunlu image string:', categoryProductItem.image);
                        }
                    } else if (categoryProductItem.image) {
                        console.warn('Bilinmeyen veya eksik image formatı, placeholder kullanılıyor (fetchCategoryProducts):', categoryProductItem.id, 'Gelen image data:', categoryProductItem.image);
                    }
                    return { ...categoryProductItem, image: finalImage };
                });
                dispatch({ type: 'FETCH_CATEGORY_PRODUCTS_SUCCESS', payload: correctedData, kategori: kategori });

                dispatch({ type: 'INCREMENT_PAGE' });
                resolve(correctedData);
            } catch (error) {
                dispatch({ type: 'FETCH_PRODUCTS_ERROR', payload: error.message });
                reject(error);
            }
        });
    }, []);

    const fetchStoreProduct = async () => {
        try {
            if (son) {
                return null;
            }
            const token = localStorage.getItem('token');
            const tkn = localStorage.getItem('tkn');
            const response = await fetch(`${getApiUrl()}/stores`, {
                method: 'GET',
                headers: {
                    'Authorization': `${token}`,
                    'Tkn': `${tkn}`,
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (data.length == 0) {
                son = true;
            }
            const correctedData = data.map(store => {
                if (typeof store.image === 'string') {
                    const imgStr = store.image.trim();

                    if (imgStr.startsWith('http')) {
                        return { ...store, image: [imgStr] };
                    }

                    if ((imgStr.startsWith('[') && imgStr.endsWith(']')) ||
                        (imgStr.startsWith('{') && imgStr.endsWith('}'))) {
                        try {
                            return { ...store, image: JSON.parse(imgStr.replace(/\\/g, '')) };
                        } catch (err) {
                            console.warn('JSON parse edilemedi:', err);
                        }
                    }

                    return { ...store, image: [imgStr] };
                }

                return store;
            });
            dispatch({ type: 'FETCH_STORE_PRODUCT_SUCCESS', payload: correctedData });

        } catch (error) {
            dispatch({ type: 'FETCH_PRODUCTS_ERROR', payload: error.message });
        }
    };
    const fetchCampaignProduct = async () => {
        try {
            if (son) {
                return null;
            }
            const token = localStorage.getItem('token');
            const tkn = localStorage.getItem('tkn');
            const response = await fetch(`${getApiUrl()}/products?store=kampanyali-urunler&sort=random`, {
                method: 'GET',
                headers: {
                    'Authorization': `${token}`,
                    'Tkn': `${tkn}`,
                    'Content-Type': 'application/json',

                },

            });
            const data = await response.json();
            if (data.length == 0) {
                son = true;
            }
            const correctedData = data.map(campaignProductItem => {
                 let finalImage = { i1: 'placeholder.jpg' }; // Varsayılan fallback

                 if (typeof campaignProductItem.image === 'object' && campaignProductItem.image !== null && campaignProductItem.image.hasOwnProperty('i1') && campaignProductItem.image.i1) {
                     finalImage = campaignProductItem.image;
                 } else if (typeof campaignProductItem.image === 'string' && campaignProductItem.image.trim() !== '') {
                     try {
                         const parsedImage = JSON.parse(campaignProductItem.image.replace(/\\/g, '\\'));
                         if (typeof parsedImage === 'object' && parsedImage !== null && parsedImage.hasOwnProperty('i1') && parsedImage.i1) {
                             finalImage = parsedImage;
                         } else {
                            console.warn('Parse edilen image beklenen yapıda değil veya i1 boş (fetchCampaignProduct):', campaignProductItem.id, 'Gelen image string:', campaignProductItem.image, 'Parse sonucu:', parsedImage);
                         }
                     } catch (error) {
                         console.error('Image JSON parse edilemedi (fetchCampaignProduct):', error, 'ID:', campaignProductItem.id, 'Sorunlu image string:', campaignProductItem.image);
                     }
                 } else if (campaignProductItem.image) {
                    console.warn('Bilinmeyen veya eksik image formatı, placeholder kullanılıyor (fetchCampaignProduct):', campaignProductItem.id, 'Gelen image data:', campaignProductItem.image);
                 }
                 return { ...campaignProductItem, image: finalImage };
            });
            dispatch({ type: 'FETCH_CAMPAIGN_PRODUCT_SUCCESS', payload: correctedData });

        } catch (error) {
            dispatch({ type: 'FETCH_PRODUCTS_ERROR', payload: error.message });
        }
    };

    const filterProductsByCategory = (categoryId, storeId) => {
        const filtered = state.products.filter(product =>
            product.categoryId === categoryId && product.storeId === storeId
        );
        dispatch({ type: 'FILTER_PRODUCTS_BY_CATEGORY', payload: { filtered, categoryId, storeId } });
    };

    return (
        <ProductContext.Provider value={{ state, dispatch, handleMaxPriceChange, fetchCampaignProduct, handleMinPriceChange, filterByPrice, searchProducts, filterProductsByCategory, fetchProductById, fetchProducts, fetchStoreProduct, fetchCategoryProducts }}>
            {children}
        </ProductContext.Provider>
    );
};